module.exports = __webpack_public_path__ + "static/img/a129.413c78c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a129.jpg
// module id = YVqj
// module chunks = 0